import React from 'react';
import { useTranslation } from 'react-i18next';
import { tArray } from 'cityads-v3/i18n/utils';

import Article, { ArticleImage } from 'cityads-v3/components/Article';

export default function ConversionPostback(props) {
  const { t } = useTranslation(['ConversionPostback']);

  return (
    <Article
      title           = {t('title')}
      pageTitle       = {t('pageTitle')}
      pageDescription = {t('pageDescription')}
      pageKeywords    = {t('pageKeywords')}
      {...props}
    >
      {tArray(t, 'p1', 'p')}

      <ArticleImage
        src={require('./img1.png')}
        caption={t('imageCaption')}
      />

      <p>
        {t('p2')}
      </p>
      <ul>
        {tArray(t, 'list1', 'li')}
      </ul>

      {tArray(t, 'p3', 'p')}

      <ul>
        {tArray(t, 'list2', 'li')}
      </ul>
    </Article>
  );
}
